<template>
  <div v-if="customPlansPage" class="section-min-width">
    <SlicesBlock :slices="slices" />
  </div>
  <Plans v-else :plans-page="true" />
</template>

<script>
import SlicesBlock from '@/components/Prismic/Landings/SlicesBlock.vue';
import Plans from 'Plans';

export default {
  nuxtI18n: {
    paths: {
      en: '/merch-plans/',
      de: '/merch-abos/',
      es: '/planes-merch/',
      pt: '/planos-merch/'
    }
  },
  components: {
    Plans,
    SlicesBlock
  },
  async asyncData({ $prismic, $cookies, store, app }) {
    try {
      let languages = $prismic.api.data.languages;
      let language = languages.find((item) => item.id.indexOf(store.$i18n.locale) != -1);

      let isLoggedIn = false;
      let isPaidUser = false;
      const strategy = $cookies.get('vx.strategy');
      const token = $cookies.get(`vx.token.${strategy}`);
      if (strategy && token) {
        isLoggedIn = true;
        try {
          const { data } = await app.$axios.get('user/me/', {
            headers: { Authorization: token }
          });
          isPaidUser = data.idPlan != 1;
        } catch (error) {
          isLoggedIn = false;
          isPaidUser = false;
        }
      }

      await store.dispatch('config/SEASONAL_STATUS');
      const isSeasonalActive = store.getters['config/isSeasonalActive'];

      let merchPlansUid = 'merch-plans';

      if (isSeasonalActive) {
        merchPlansUid = merchPlansUid + '-seasonal';
      }

      if (isLoggedIn && isPaidUser) {
        merchPlansUid = merchPlansUid + '-paid';
      }

      const result = await $prismic.api.getByUID('post', merchPlansUid, { lang: language.id });

      if (!result) {
        return {
          customPlansPage: false
        };
      }
      const pageConfiguration = result.data.body.find(
        (slice) => slice.slice_type === 'page_configuration'
      );
      if (pageConfiguration) {
        await store.dispatch('config/SET_PRISMIC_PAGE_CONFIGURATION', pageConfiguration.primary);
      }
      return {
        slices: result.data.body,
        customPlansPage: true
      };
    } catch (e) {
      return {
        customPlansPage: false
      };
    }
  },
  head() {
    const i18nSeo = this.$seoPlugin({ slash: true });
    return {
      link: [...i18nSeo.link]
    };
  },
  mounted() {
    this.$store.commit('vectors/SET_ACTUAL_VECTOR', { vector: null, vectorId: null });
  }
};
</script>
